import { createLazyResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { ReferralRepository } from '~/repositories/referral';

const repo = new ReferralRepository();

export const [ReferralProvider, useReferral] = createMagicDoorContext('Referral', () => {
  const [referralLink, { fetch, refetch }] = createLazyResource(() => repo.getReferralLink());
  return {
    get referralLink() {
      fetch();
      return referralLink;
    },
    refetch,
  };
});
